export const SPACELIFT_VCS_REPO_COMMITS_SEARCH_FILTERS_STORAGE_KEY =
  "spaceliftVcsRepoCommitsSearchFilters";
